module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-cate"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login_header",
    attrs: {
      "id": "module_closeCata"
    },
    on: {
      "click": function($event) {
        return _vm.closeCata($event)
      }
    }
  }, [_c('p', {
    staticClass: "login_logo"
  }), _vm._v(" "), _c('p', {
    staticClass: "login_more_logo",
    attrs: {
      "id": "module_controlCata"
    },
    on: {
      "click": function($event) {
        return _vm.controlCata($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isuser_cata),
      expression: "isuser_cata"
    }],
    staticClass: "user_cata"
  }, [_c('div', {
    staticClass: "cata_mask"
  }, [_c('p', {
    directives: [{
      name: "mylink",
      rawName: "v-mylink",
      value: ('/index/myrelation'),
      expression: "'/index/myrelation'"
    }],
    staticClass: "myrelation",
    attrs: {
      "id": "user_cata_myrelation"
    }
  }, [_c('i', {
    staticClass: "re_icon"
  }), _vm._v("我的图谱\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "outLogin",
    attrs: {
      "id": "user_cata_outLogin"
    },
    on: {
      "click": function($event) {
        return _vm.outLogin()
      }
    }
  }, [_c('i', {
    staticClass: "out_icon"
  }), _vm._v("退出登录\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "module_middle"
  }, [_c('div', {
    staticClass: "shape"
  }), _vm._v(" "), _c('div', {
    staticClass: "module_inner"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "module_right"
  }, [_c('ul', [_c('li', {
    directives: [{
      name: "mylink",
      rawName: "v-mylink",
      value: ('/index/overview'),
      expression: "'/index/overview'"
    }],
    attrs: {
      "id": "all_view"
    }
  }, [_c('p', [_vm._v("企业全貌族谱查询")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "mylink",
      rawName: "v-mylink",
      value: ('/index/multiquery'),
      expression: "'/index/multiquery'"
    }],
    attrs: {
      "id": "multi_view"
    }
  }, [_c('p', [_vm._v("多节点关联查询")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "mylink",
      rawName: "v-mylink",
      value: ('/index/contrlWay'),
      expression: "'/index/contrlWay'"
    }],
    attrs: {
      "id": "contrl_view"
    }
  }, [_c('p', [_vm._v("企业控制路径")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "mylink",
      rawName: "v-mylink",
      value: ('/index/subrelation'),
      expression: "'/index/subrelation'"
    }],
    attrs: {
      "id": "ess_view"
    }
  }, [_c('p', [_vm._v("企业实质关联族谱")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "mylink",
      rawName: "v-mylink",
      value: ('/index/riskView'),
      expression: "'/index/riskView'"
    }],
    attrs: {
      "id": "risk_view"
    }
  }, [_c('p', [_vm._v("企业风险关联视图")])]), _vm._v(" "), _vm._m(2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('canvas', {
    attrs: {
      "id": "homeCanvas",
      "width": "100%",
      "height": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module_left"
  }, [_c('h1', [_vm._v("企业关联关系洞察"), _c('br'), _vm._v("大数据平台")]), _vm._v(" "), _c('p', {
    staticClass: "module_content_comm"
  }, [_vm._v("基于企业工商大数据，挖掘公开信息中企业的股权投资、高管任职与登记电话、地址关联关系。以某一企业为起点，根据可配置的探查层级与关系类型，逐层向外梳理企业的关系族谱。直观立体的展示企业在工商数据维度中的关联关系，形成客观全貌关联族谱")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("全局关联族谱视图")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-84954f24"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/ModuleCate.vue
// module id = 513
// module chunks = 10